import { createContext, useContext } from "react";

export interface TargetingValidationApi {
  // Bumped by the builder mount when the user advances with an incomplete step,
  // so targeting cards flash their field-level errors instead of silently blocking.
  version: number;
}

export const TargetingValidationContext = createContext<TargetingValidationApi>({ version: 0 });

export const useTargetingValidation = () => useContext(TargetingValidationContext);
